import { getRoute } from "../client"
import type { EngagementDto } from "../../shared/engagementTypes"

export const engagementStateRoute = getRoute<EngagementDto>("/api/engagement")
